import { Input } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './EmailScreen.module.css';
import { emailSchema } from './EmailScreen.schema';
import { useGetApplicationQuery } from '../../../../api/lendingApi/lendingApiQueries';
import { TMobileSignupForm } from '../../form/form';
import { useStageFieldTracking } from '../../form/MobileSignupFieldTracking';
import { useMobileSignupAccountSetup } from '../../form/useMobileSignupAccountSetup';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

export const EmailScreen = () => {
  const { t } = useLingui();
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { application } = useGetApplicationQuery();
  const { setUpAccount } = useMobileSignupAccountSetup();
  const { validateAndContinue, isSubmitting, submitError } =
    useScreenValidation(emailSchema, () => setUpAccount(getValues()));
  const { fieldProps } = useStageFieldTracking();

  return (
    <StepLayout
      stageTitle={t`Credit request`}
      heading={t`What is your business email address?`}
      subHeading={t`You can log in to this application with this email:`}
      onContinue={validateAndContinue}
      loading={isSubmitting}
      submitError={submitError}
      fieldProps={fieldProps}
    >
      <Input
        {...register('email')}
        type="email"
        label={t`Email address`}
        placeholder={t`firstname@example.com`}
        error={errors.email?.message}
        disabled={Boolean(application)}
        className="fs-mask"
      />
      <p className={styles.legal}>
        <Trans>
          I hereby consent to the processing of my personal data in accordance
          with our current{' '}
          <a
            href="https://www.iwoca.de/datenschutzhinweis/"
            target="_blank"
            rel="noreferrer"
          >
            privacy policy
          </a>{' '}
          of iwoca Deutschland GmbH. This consent can be withdrawn at any time.
          I agree to the{' '}
          <a
            href="https://www.iwoca.de/allgemeine_geschaeftsbedingungen/"
            target="_blank"
            rel="noreferrer"
          >
            terms and conditions
          </a>{' '}
          of iwoca Deutschland GmbH.
        </Trans>
      </p>
    </StepLayout>
  );
};
